import { useEffect, useState } from "react";
import { ProjectWithName, UserProject, UserWithEmail, ValidationErrors } from "../../types/admin";
import EmailInput from "../InputComponents/EmailInput";
import StringInput from "../InputComponents/StringInput";
import SwitchInput from "../InputComponents/SwitchInput";
import ErrorMessage from "../Utils/ErrorMessage";
import SuccessMessage from "../Utils/SuccessMessage";
import DropdownNumberMandatory from "../InputComponents/DropdownNumberMandatoryComponent";
import DropdownStringMandatoryComponent from "../InputComponents/DropdownStringMandatoryComponent";
import DropDownStringOptionAndValue from "../InputComponents/DropDownStringOptionAndValue";
import { useMsal } from "@azure/msal-react";
import { AdminApi } from "../../Api/AdminApi";
import DDNumberValue from "../InputComponents/DDNumberValue";
import SearchableDropDownStringOptionAndValue from "../InputComponents/SearchableDropDownStringOptionAndValue";

interface UserProjectComponentProps{
    onChange : (field: keyof UserProject) => (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleSubmit : () => Promise<boolean>; // Changed return type to boolean
    userProject : UserProject;
    errors : ValidationErrors;
    successMessage : string;
    errorMessage?: string;
    projectId? : string | null;
    userToExclude? : string[];
}
function UserProjectComponent({
    onChange,
    handleSubmit,
    userProject,
    errors,
    successMessage,
    errorMessage = "",
    projectId = null,
    userToExclude = []
}:UserProjectComponentProps)
{
  const { instance, accounts } = useMsal();
  const api = new AdminApi(accounts[0], instance);


    const [ users, setUsers] = useState<UserWithEmail[]>();
    const [ projects, setProjects] = useState<ProjectWithName[]>();
    const [ isHidden, setIsHidden] = useState<boolean>(true);
  
  const fetchUsers = async () => {
    setUsers(await api.getUsersWithEmail());
  };
  const fetchProjects = async () => {
    if(projectId !== null)
    {
        setProjects(await api.getProjectsWithName());
    }
  };
    useEffect(() => {
        fetchUsers();
        fetchProjects();
    }, []);

    const handleOpen = () =>{
        setIsHidden(false);
    }

    const handleSubmitClick = async() =>
    {
        const success = await handleSubmit();
        // Only hide the form if submission was successful
        if (success) {
            setIsHidden(true);
        }
    } 
    return(<>
    {isHidden? 
        <div className="row">
        <div className="col-12 d-flex justify-content-center">
          <input
            className="big-button d-block mx-auto mt-5"
            type="submit"
            value={"Add user to project"}
            onClick={() => handleOpen()}
          />
        </div>
      </div>
    :<>
    <div className="user-container">
        <div className="row">
          <div className="col-6 visibility-button">
            <h2 className="container-title">
              Add user to project
            </h2>
          </div>
        </div>
        <div className="form-container">
          <div className="error-container">
            <SuccessMessage
              message={successMessage}
            />
            {errorMessage && (
              <div className="error-message" style={{ color: "red", marginBottom: "15px" }}>
                {errorMessage}
              </div>
            )}
          </div>
          
          <div className="row">
            <div className="col-sm-12">
                {users === undefined? null :<>
              <SearchableDropDownStringOptionAndValue 
                    listInputs={users?.filter(user => 
                        user.email && !userToExclude.includes(user.email)
                    )}
                    label={"User"}
                    inputName={"user"}
                    value={userProject.userId}
                    handleOnChange={onChange("userId")} 
                    valueKey={"id"} 
                    displayKey={"email"}                />
            <ErrorMessage errors={errors["emailId"]} /></>}
            </div>
            <div className="col-sm-12">
                {projects === undefined || projectId != null? null :<>
              <DropDownStringOptionAndValue 
                    listInputs={projects}
                    label={"Project"}
                    inputName={"project"}
                    value={userProject.projectId}
                    handleOnChange={onChange("projectId")} 
                    valueKey={"id"} 
                    displayKey={"name"}                />
            <ErrorMessage errors={errors["projectId"]} /></>}
            </div>
            <div className="col-sm-12">
              <DDNumberValue 
                        listInputs={["-", "Encoder","Validator", "Project Verificator", "Project Approver" ]} 
                        label={"User role"} 
                        inputName={"role"} 
                        value={userProject.role} 
                        handleOnChange={onChange("role")}
                        />
            <ErrorMessage errors={errors["role"]} /> 
            </div>

          </div>
        
          <div className="row">
            <div className="col-12 d-flex justify-content-center">
              <input
                className="big-button d-block mx-auto mt-5"
                type="submit"
                value={"Add user to project"}
                onClick={handleSubmitClick}
              />
            </div>
          </div>
        </div>
      </div></>}</>)
}

export default UserProjectComponent;